import React from 'react';

export default function CRM({
    input,
    AddDataField,
    validate,
    confirmInput,
    crmValue
}) {
    function crmMask(value) {
        return value
          .replace(/\D/g, "") 
         
      }

    return (
        <input 
            name={input.nome} 
            id={"crm"}
            type="text"
            placeholder={input.placeholder}
            onChange={e => AddDataField(input, crmMask(e.target.value))} 
            onBlur={e => (input.obrigatorio ? confirmInput(e.target) : {}) && (validate ? validate(input, e?.target?.value) : {})} 
            value={crmValue || ''}
            required={input.obrigatorio ? true : false}
        />
    );
    
   
}       
        
